<footer class="footer">
    <div class="footer-container">

        <!-- Logo Section -->
        <div class="footer-column logo-section">
            <div class="logo">
                <div class="logo-icon">
                       <img style="margin-top:-19px;" src="../../../../assets/images/icon/NeoHRMZ_logo.svg" alt="Neohrmz">
                </div>
                <div class="logo-text">
                    <h3>NeoHRMZ</h3>
                    <span>HRMZ</span>
                </div>
            </div>

            <p>
                An all-in-one HR management platform to streamline processes,
                engage employees, and drive business success.
            </p>

            <div class="social-icons">
                <a href="#" target="_blank"><i class="fab fa-linkedin-in" aria-hidden="true"></i></a>
                <a href="#" target="_blank"><i class="fab fa-twitter" aria-hidden="true"></i></a>
                <a href="#" target="_blank"><i class="fab fa-facebook-f" aria-hidden="true"></i></a>
                <a href="#" target="_blank"><i class="fab fa-instagram" aria-hidden="true"></i></a>
            </div>
        </div>

        <!-- Product -->
        <div class="footer-column">
            <h4>Product</h4>
           
                <li><a class="pointer" (click)="goTo('/dummy-test')">All Features</a></li>
                <li><a class="pointer" (click)="goTo('/emp-management-footer')">Employee Management</a></li>
                <li><a class="pointer" (click)="goTo('/payroll-custom-brand')">Payroll</a></li>
                <li><a class="pointer" (click)="goTo('/attendance-custom-brand')">Attendance</a></li>
                <li><a class="pointer" (click)="goTo('/performance-custom-brand')">Performance</a></li>
                <li><a class="pointer" (click)="goTo('/recruitment-custom-brand')">Recruitment</a></li>
                <li><a class="pointer" (click)="goTo('/ai-assistant-custom-brand')">AI Assistant</a></li>
                <!-- <li><a class="pointer" (click)="goTo('/products')">Pricing</a></li> -->
           
        </div>

        <!-- Solutions -->
        <div class="footer-column">
            <h4>Solutions</h4>

                <li><a class="pointer" (click)="goTo('/enterprise-custom-brand')">Enterprise</a></li>
                <li><a class="pointer" (click)="goTo('/startups-custom-brand')">Startups</a></li>
                <li><a class="pointer" (click)="goTo('/global-custom-brand')">Global Teams</a></li>
                <li><a class="pointer" (click)="goTo('/remote-custom-brand')">Remote Work</a></li>
                <li><a class="pointer" (click)="goTo('/manufacturing-custom-brand')">Manufacturing</a></li>
                <li><a class="pointer" (click)="goTo('/healthcare-custom-brand')">Healthcare</a></li>
            
        </div>

        <!-- Resources -->
        <div class="footer-column">
            <h4>Resources</h4>
           
                <!-- <li><a class="pointer" href="https://blog.whiterobe.in/" target="_blank" >Blog</a></li> -->
                <li><a class="pointer" (click)="goTo('/documentation-custom-brand')" >Documentation</a></li>
                <li><a class="pointer" (click)="goTo('/apireference-custom')" >API Reference</a></li>
                <li><a class="pointer" (click)="goTo('/blog-custom')" >Blog</a></li>
                <!-- <li><a class="pointer" (click)="goTo('/guides')" >Guides</a></li> -->
                <li><a class="pointer" (click)="goTo('/hr-academy')" >HR Academy</a></li>
                <li><a class="pointer" (click)="goTo('/webinars')" >Webinars</a></li>
                <li><a class="pointer" (click)="goTo('/status-page')" >Status Page</a></li>
            
        </div>

        <!-- Company -->
        <div class="footer-column">
            <h4>Company</h4>
         <li><a class="pointer" (click)="goTo('/about-us-custom')">About Us</a></li>
        <!-- <li><a class="pointer" (click)="goTo('#')">Branding</a></li> -->
        <li><a class="pointer" (click)="goTo('/careers-custom-brand')">Careers</a></li>
        <li><a class="pointer" (click)="goTo('/press-kit-custom')">Press Kit</a></li>
        <li><a class="pointer" (click)="goTo('/partners-custom-brand')">Partners</a></li>
        <li><a class="pointer" (click)="goTo('/contact-custom-brand')">Contact</a></li>
            
        </div>

        <!-- Newsletter -->
        <div class="footer-column newsletter">
            <h4>Newsletter</h4>

            <p>
                Subscribe to get the latest updates and HR insights.
            </p>

            <div class="newsletter-box">
                <input type="email" placeholder="Enter your email">
                <button>&#8594;</button>
            </div>
        </div>

    </div>

    <hr>

    <div class="footer-bottom">
        <p>© 2026 NeoHRMZ . All rights reserved.</p>

        <div class="footer-links">
            <a (click)="goTo('/terms-and-conditions')" style="cursor: pointer;">Terms and Conditions</a>|
            <a (click)="goTo('/privacy')" style="cursor: pointer;">Privacy Policy</a>|
            <!-- <a (click)="goTo('#')" style="cursor: pointer;">Security</a>| -->
            <a (click)="goTo('/pricing-policy')" style="cursor: pointer;">Pricing Policy</a>|
            <a (click)="goTo('/cancellation-policy')" style="cursor: pointer;">Cancellation Policy</a>|
            <a (click)="goTo('/refund-policy')" style="cursor: pointer;">Refund Policy</a>
        </div>
    </div>

</footer>

<!-- Font Awesome -->
<link rel="stylesheet"
href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css">